import request from '@/router/axios';

const upload = (filename, file) => {
  const formData = new FormData()
  formData.append(filename, file)
  return request({
    url: '/api/blade-resource/oss/endpoint/put-file-attach',
    method: 'post',
    data: formData,
  })
}
export default {
  upload,
}
